import { render, staticRenderFns } from "./InvalidGoodsList.vue?vue&type=template&id=6a18b16e&scoped=true&"
import script from "./InvalidGoodsList.vue?vue&type=script&lang=js&"
export * from "./InvalidGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./InvalidGoodsList.vue?vue&type=style&index=0&id=6a18b16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a18b16e",
  null
  
)

export default component.exports